export const getYoutubeThumbnail = (url) => {
    const videoId = url.split('/embed/')[1]?.split('?')[0]; // Extract video ID
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`; // Generate thumbnail URL
  };
